export const FETCH_ALLASSIGNROOM_REQUEST = 'FETCH_ALLASSIGNROOM_REQUEST'
export const FETCH_ALLASSIGNROOM_SUCCESS = 'FETCH_ALLASSIGNROOM_SUCCESS'
export const FETCH_ALLASSIGNROOM_FALIURE = 'FETCH_ALLASSIGNROOM_FALIURE'
